


































import { mapState } from 'vuex';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import BookingFormOpenedGaEvent from '@/helpers/ga/events/BookingFormOpenedGaEvent';
import { sendGaEvent } from '@/helpers/ga/gaSend';
import { getContentTypeFromEntityType } from '@/helpers/ga/params/contentTypeParam';
import BookingFormSubmittedGaEvent from '@/helpers/ga/events/BookingFormSubmittedGaEvent';

@Component({
  components: {
    TheAwaitingConfirmationIcon: () => import('@/components/icons/TheAwaitingConfirmationIcon.vue'),
    TheConfirmedIcon: () => import('@/components/icons/TheConfirmedIcon.vue'),
    TheNotConfirmedIcon: () => import('@/components/icons/TheNotConfirmedIcon.vue'),
    TheUserAttendIcon: () => import('@/components/icons/TheUserAttendIcon.vue'),
    LikeToAttend: () => import('@/components/partials/LikeToAttend.vue'),
  },
  computed: {
    ...mapState(['museumRole']),
  },
})
export default class LikeToAttendAction extends Vue {
  @Prop() event!: any;

  isLoader = false;
  isRequested = false;
  showForm = false;

  get actionDisabled() {
    return !!this.activeBooking;
  }

  get actionLabel() {
    return this.activeBooking ? this.activeBooking.status_for_human : this.bookingTypeTitle;
  }

  get activeBooking() {
    if (this.event.activeBooking) {
      return this.event.activeBooking;
    }
    if (this.isRequested) {
      return {
        is_awaiting_status: true,
        is_confirmed_status: false,
        is_not_confirmed_status: false,
        status_for_human: 'Awaiting confirmation',
      };
    }
    return null;
  }

  get showAction() {
    return this.activeBooking || (!this.event.is_expired && !this.event.fully_booked);
  }

  get bookingTypeTitle() {
    return this.event.bookingTypeTitle || "I'd Like to Attend";
  }

  @Watch('showForm', { immediate: true })
  watchShowForm(isShow: boolean) {
    this.$store.dispatch(isShow ? 'disableScroll' : 'enableScroll');

    if (isShow) {
      const gaEvent = new BookingFormOpenedGaEvent()
        .addBookingType(this.event.bookingFormType)
        .addContentType(getContentTypeFromEntityType(this.event.__typename))
        .addContentId(this.event.id)
        .addContentName(this.event.title)
        .addCtaName(this.actionLabel)
        .addPartnerName(this.event.corporatePartner);

      sendGaEvent(gaEvent);
    }
  }

  showLikeRequested() {
    this.isRequested = true;

    const gaEvent = new BookingFormSubmittedGaEvent()
      .addBookingType(this.event.bookingFormType)
      .addContentType(getContentTypeFromEntityType(this.event.__typename))
      .addContentId(this.event.id)
      .addContentName(this.event.title)
      .addCtaName(this.actionLabel)
      .addPartnerName(this.event.corporatePartner);

    sendGaEvent(gaEvent);

    this.showForm = false;
  }

  open() {
    if (!this.museumRole || this.$route.name === 'academy') {
      this.showForm = true;
      return;
    }

    if (this.$route.name === 'event') {
      if (!this.event.is_virtual_type && !this.event.enthusiast_membership_level) {
        this.$emit('show-museum-modal');
      } else {
        this.showForm = true;
      }
    }

    if (this.$route.name === 'art-fair' || this.$route.name === 'art-trip' || this.$route.name === 'miniCultivist') {
      this.$emit('show-museum-modal');
    }
  }

  close() {
    this.showForm = false;
  }
}
